import { gql, useMutation } from 'urql';
import type { UpdateSettingInput } from '@features/modal-invitation/api/updateSetting';

export const SEND_MESSAGES_MUTATION = gql`
  mutation SendMessages(
    $ticketIds: [Int!]!
    $messageTemplate: String!
    $emailMessageTemplate: String!
    $contentType: String!
    $channel: [String!]!
    $sendTicketCalendarMeeting: Boolean
    $eventSettings: UpdateSetting
  ) {
    sendMessages(
      ticketIds: $ticketIds
      messageTemplate: $messageTemplate
      emailMessageTemplate: $emailMessageTemplate
      contentType: $contentType
      channel: $channel
      sendTicketCalendarMeeting: $sendTicketCalendarMeeting
      eventSettings: $eventSettings
    ) {
      totalMessages
      attempt
      contentType
    }
  }
`;

export enum SendChannel {
  SMS = 'SMS',
  Email = 'EMAIL',
  Both = 'BOTH',
  VK = 'VK',
}

export enum SendContentType {
  Ticket = 'TICKET',
  Invite = 'INVITE',
  Registration = 'REGISTRATION',
}

export enum TicketDeliveryMethod {
  SMS = 'SMS',
  Email = 'EMAIL',
  Both = 'BOTH',
  VK = 'VK',
}

export interface SendMessagesInput {
  ticketIds: number[];
  messageTemplate: string | null;
  emailMessageTemplate: string | null;
  contentType: SendContentType;
  channel: SendChannel[];
  eventSettings?: UpdateSettingInput | null;
  sendTicketCalendarMeeting?: boolean;
}

export interface SendMessagesResponse {
  sendMessages: {
    totalMessages: number;
    attempt: number;
    contentType: string;
  };
}

export const useSendMessages = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<SendMessagesResponse, SendMessagesInput>(
    SEND_MESSAGES_MUTATION
  );

  const sendMessages = (variables: SendMessagesInput) => {
    return executeMutation(variables);
  };

  return {
    data: data?.sendMessages,
    error,
    fetching,
    sendMessages,
  };
};
